// helpers
import { CART_INTERACTION_LOCATION } from 'shared/helpers/analytics/constants/cart';
import NFA from 'shared/helpers/analytics/NFAnalytics';
import DTM from 'shared/helpers/DTM';
import { storeAnalyticsDataInLocal } from 'shared/helpers/storage/storeData';

//constants
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';

const EVENTS = {
  SIGN_IN_CLICK: 'sign-in-click',
  SIGN_IN_ATTEMPT: 'signin-attempt',
  SIGN_IN_SUCCESS: 'signin-success',
  SIGN_IN_FAILED: 'signin-failed',
  REGISTER_CLICK: 'register-click',
  REGISTER_SUCCESS: 'register-success',
  REGISTER_FAILED: 'register-failed',
  CART_OPEN: 'cart-open',
  BACK_BUTTON_CLICKED: 'back-button-clicked',
  NF_LOGO_CLICK: 'header-logo-click',
};

const PAGE_NAME = 'SignIn page';
const EVARS = {
  SIGN_IN_ATTEMPT: 'SignIn Attempted',
  SIGN_IN_SUCCESS: 'SignIn Success',
  SIGN_IN_FAILED: 'SignIn Failed',
  REGISTER_CLICK: 'Register page',
  REGISTER_SUCCESS: 'Register Success',
  REGISTER_FAILED: 'Register Failed',
};

export const TOPNAV_BASE_TRACKING_PARAM = 'root=topnav_1';

export const onSignInClick = () => DTM.track(EVENTS.SIGN_IN_CLICK, { pagetype: PAGE_NAME });

export const onSignInAttemptClick = () =>
  DTM.track(EVENTS.SIGN_IN_ATTEMPT, { eVar52: EVARS.SIGN_IN_ATTEMPT });

export const onSignInSuccess = () =>
  DTM.track(EVENTS.SIGN_IN_SUCCESS, { eVar54: EVARS.SIGN_IN_SUCCESS });

export const onSignInFailed = () =>
  DTM.track(EVENTS.SIGN_IN_FAILED, { eVar54: EVARS.SIGN_IN_FAILED });

export const onRegisterClick = () =>
  DTM.track(EVENTS.REGISTER_CLICK, { eVar54: EVARS.REGISTER_CLICK });

export const onRegisterSuccess = (customerId: string) =>
  DTM.track(EVENTS.REGISTER_SUCCESS, { eVar54: EVARS.REGISTER_SUCCESS, customer_id: customerId });

export const onRegisterFailed = () =>
  DTM.track(EVENTS.REGISTER_FAILED, { eVar54: EVARS.REGISTER_FAILED });

export const onCartClick = (cartFrom: string, cartInteractedLocation?: string) => {
  NFA.updateDatalayerBeforeNext({
    cartInteractionLocation:
      cartInteractedLocation === CART_INTERACTION_LOCATION.VIEW_BAG
        ? CART_INTERACTION_LOCATION.VIEW_BAG
        : undefined,
  });
  storeAnalyticsDataInLocal({ cartFrom: cartFrom });
};

export const trackBackButtonClicked = () => {
  NFA.track({
    event: EVENTS.BACK_BUTTON_CLICKED,
    type: TRACK_TYPE.EVENT,
  });
};

export const nfLogoClicked = () => {
  // updating the data layer and sending event143 based on this value on page load rule
  // this is a dummy event sent to update layer on next page load
  DTM.track(EVENTS.NF_LOGO_CLICK, { headerLogoClick: 'true' });
};
